import React, { useState, useEffect } from "react";
import { fetchPateintAssessmentsLogic } from "../../../../store/features/patient/assessmentsSlice";
import { notify } from "../../../../util/helpers";

const PatientCocmConsentData = ({ singlePatientData, bhiData }) => {
  const [patientAssessments, setPatientAssessments] = useState([]);

  useEffect(() => {
    fetchPateintAssessmentsLogic(singlePatientData?.id)
      .then((result) => {
        setPatientAssessments(result.data);
      })
      .catch((error) => {
        notify("Something went wrong", "error");
        console.log(error);
      });
  }, []);

  const getScheduledAssessments = () => {
    let res = "";
    if (patientAssessments)
      patientAssessments?.forEach((element, index) => {
        if (index === patientAssessments.length - 1)
          res += ` and ${element.assessment_name}`;
        else res += `${element.assessment_name}, `;
      });

    return res;
  };
  return (
    <article className="px-4">
      {singlePatientData?.first_name} {singlePatientData?.last_name} was
      consented and enrolled in treatment plan for Psychiatric Collaborative Care Services (CoCM)
      (CPT Codes 99492, 99493, and 99494 and HCPCS code G2214 ) for {bhiData?.diagnosis}. 
      The initial face-to-face clinical session was done on done on {bhiData?.enrollment_date}. 
      Consent was also obtained from the patient to consult with relevant specialists including a psychiatric
      consultant if needed. As part of this consent, the patient was informed
      that there is beneficiary cost-sharing, including potential deductible and
      coinsurance amounts for both in-person and non-face-to-face services that
      are provided.
      <br /> <br />
      Patient was counseled on symptoms related to their diagnosis in the office
      and instructed to call our office if the symptoms worsened.
      <br /> <br />
      Patient to be closely monitored, screened and counseled according to the
      psychological tests results {getScheduledAssessments()}. These
      psychological tests are repeated monthly to reassess presence or absence
      of mental stress that a patient experiences to help adjust this treatment
      plan.
      <br /> <br />
      Care management services for the behavioral health diagnosis encompass 70 minutes, 60 minutes or additional 30 minutes of clinical time depending on CPT code billed. 
      This care management services is directed by a physician or other qualified healthcare professional, 
      to be performed per calendar month including initial assessment, 
      follow-up monitoring, using applicable validated clinical rating scales, 
      behavioral health care planning in relation to behavioral/psychiatric health problems, 
      facilitating and coordinating treatment such as psychotherapy, pharmacotherapy, counseling, 
      and/or psychiatric consultation and continuity of care with a designated member of the care team.
      <br /> <br />
      Additionally, the patient was instructed to keep mood, anxiety and journal
      logs using a HIPAA-compliant mobile application. The clinical care team
      can remotely monitor patient wellbeing using web-based dashboards and plan
      care for the patient. The mobile app also provides patients with
      personalized content based on their mental health status including
      behavioral health resources, guided meditation, and crisis support. The
      care team helped the patient set up their mobile app account during the
      initial visit and reviewed how to use the mobile app.
    </article>
  );
};

export default PatientCocmConsentData;
